import React, { useState } from 'react';
import {
	CaseTypeType,
	useLazyWorkplaceCaseTypesQuery,
} from '../../../../graphql/graphql';
import { SelectValue } from '../../../../Components/Base/Select/Select';
import { FieldError } from 'react-hook-form';
import { useAppContext } from '../../../../Services/AppContext';
import { useEffectAsync } from '../../../../helpers';
import MultiSelectWithCheckList from '../../../Base/Components/Inputs/MultiSelectWithCheckList/MultiSelectWithCheckList';

interface Props {
	onChange?: (value: SelectValue) => void;
	workplaceId?: string;
	value?: SelectValue;
	error?: FieldError;
	placeholder?: string;
}

const WorkplaceCaseTypeMultiSelectWithCheckList: React.FC<Props> = props => {
	const { value, onChange, workplaceId, placeholder } = props;
	const [defaultValue, setDefaultValue] = useState<SelectValue | undefined>(
		value,
	);
	const [isReady, setIsReady] = useState(false);
	const [options, setOptions] = useState<SelectValue[]>();
	const [getWorkplaceCaseTypes] = useLazyWorkplaceCaseTypesQuery();
	const { userData } = useAppContext();
	const currentWorkplaceId = workplaceId ?? userData.workplaceId;

	useEffectAsync(async () => {
		setIsReady(isReady);
		const items: SelectValue[] = [];

		const { workplaceCaseTypes } = await getWorkplaceCaseTypes({
			workplaceId: currentWorkplaceId,
			caseTypeTypes: [CaseTypeType.CaseType],
		}).unwrap();

		for (const workplaceCaseType of workplaceCaseTypes?.data || []) {
			if (workplaceCaseType && workplaceCaseType.caseType) {
				items.push({
					value: workplaceCaseType.caseType.id,
					label: workplaceCaseType.caseType.label || '',
				});
			}
		}

		setOptions(items);
		setIsReady(true);
	}, []);

	if (isReady) {
		return (
			<MultiSelectWithCheckList
				{...props}
				options={options}
				onChange={onChange}
				value={defaultValue?.label ? defaultValue : value}
				placeholder={placeholder}
			/>
		);
	}

	return null;
};

export default WorkplaceCaseTypeMultiSelectWithCheckList;
